import { useEffect } from 'react';
import { useDatasetFormData } from '../../../hooks/context/useDatasetFormData';
import { useFormTokenChainContext } from '../../../hooks/context/useFormTokenChainContext';
import { focusFormFieldByName } from '../../../utils/forms/focusFormFieldByName';
import {
  applyPendingFullscreenHandler,
  FireEventFn,
  PendingFullscreenHandlerMarker,
} from '../utils/applyPendingFullscreenHandler';

// Fires the field's handlers after a fullscreen reference confirm.
// Waits until the form has finished loading and seeding formData from the token.
export const usePendingFullscreenHandler = (fireEvent: FireEventFn): void => {
  const { form, actualToken, isLoading } = useDatasetFormData();
  const { updateTokenValues } = useFormTokenChainContext();

  useEffect(() => {
    const marker = actualToken?.meta?.pendingFullscreenHandler as
      | PendingFullscreenHandlerMarker
      | undefined;
    if (!marker || isLoading || !form?.items?.length || !actualToken) return;

    applyPendingFullscreenHandler(marker, form.items, fireEvent);

    // Suppress open-on-focus so the originating reference field doesn't reopen its popover.
    focusFormFieldByName(marker.field, { suppressOpenOnFocus: true });

    const nextMeta = { ...(actualToken.meta ?? {}) };
    delete (nextMeta as Record<string, unknown>).pendingFullscreenHandler;
    updateTokenValues({ ...actualToken, meta: nextMeta });
  }, [actualToken, form, isLoading, fireEvent, updateTokenValues]);
};
